import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

export const NewJobPostingModalContentSkeleton = () => {
  return (
    <Box width="full" gap="s16">
      <Box gap="s12">
        <Skeleton height="s16" width="s120" />
        <Skeleton height="s32" width="full" />
      </Box>

      <Box gap="s16">
        <Grid variant="fixed">
          {[...Array(6)].map((_, index) => (
            <Box gridColSpan={{ xxs: 1, xs: 6 }} key={`input-skeleton-${index}`} gap="s12">
              <Skeleton height="s16" width="s120" />
              <Skeleton height="s40" width="full" />
            </Box>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}
